import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const newsNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.News,
  icon: 'newspaper',
  route: `/${RoutesEnum.News}`,
};
